/*
    Storage key is used to name and track opened tabs among parent (opener) and children (opened)
*/
import { getGuid } from 'owa-guid';

let storageKey = '';

export function set(key: string) {
    storageKey = key;
}

export function generate() {
    storageKey = getGuid();
    return storageKey;
}

export function extract(): string | null {
    // try/catch to catch exception if opener is cross-origin
    try {
        if (window.opener?.name) {
            const match = window.opener.name.match(/[a-z]*_(.*)/);
            return match?.[1];
        }
    } catch {
        return null;
    }

    return null;
}

export function getTabKey(tabName: string) {
    return `${tabName.toLowerCase()}_${storageKey}`;
}
